import { Injectable } from '@angular/core';
import { SalesforceDataSourceApiService } from 'datasource-service-lib';
import { FilterLabel, IDocumentType, IDocumentTypeService } from 'document-type-picker-lib';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SalesforceDocumentTypeService implements IDocumentTypeService {
  constructor(private apiService: SalesforceDataSourceApiService) {}

  getDocumentTypeLabel(): string {
    return 'file';
  }

  getDocumentTypes(entityType: string, filterLabel?: FilterLabel): Observable<IDocumentType[]> {
    return of([]);
  }

  getRecordTerm(): string {
    return 'entity';
  }
}
